import React from 'react';
import PropTypes from 'prop-types';
//import cn from 'classnames';

import VideoListBlock from 'components/VideoListBlock';

class YoutubeVideoBlock extends React.Component {

    static propTypes = {
        size: PropTypes.string,
        blockId: PropTypes.number.isRequired,
        contentType: PropTypes.string,
        title: PropTypes.string,
        subtitle: PropTypes.string,
        description: PropTypes.string,
        youtubeVideoId: PropTypes.string.isRequired,
        previewImage: PropTypes.string,
        previewImageMobile: PropTypes.string,
        playVideoLabel: PropTypes.string.isRequired,
        isFullHeight:PropTypes.bool
    }

    render() {
        const { size, blockId, contentType, playVideoLabel,isFullHeight } = this.props;
        const { title, subtitle, description, youtubeVideoId, previewImage, previewImageMobile } = this.props;
        const video = { title, subtitle, description, youtubeVideoId, previewImage, previewImageMobile } ;
        const videos = [video];

        const videoListModel = {
            size,
            blockId, 
            contentType,
            videos,
            playVideoLabel,
            isFullHeight
        };
        {/* BE: previewImageMobile image recommended size is 560x996px */}
        return (
            <VideoListBlock {...videoListModel} />
        );
    }    
}

export default YoutubeVideoBlock;


// WEBPACK FOOTER //
// ./src/components/YoutubeVideoBlock/YoutubeVideoBlock.jsx